import React, { useEffect, useState } from "react";
import { ChantButton, ChantSelect } from "../../../../../../CommonComponents";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../../../store/adminData/adminData";

const RegCodeRole = ({
  onCloseModal,
  regCodeRole,
  saveRegCodeRole,
  isRoleSaving,
}) => {
  const ROLES = [
    { label: "Member", value: "member" },
    { label: "Non-member", value: "fan" },
  ];

  const [localRegCodeRole, setLocalRegCodeRole] = useState(null);

  useEffect(() => {
    setLocalRegCodeRole(regCodeRole);
  }, [regCodeRole]);

  const groupData = useAdminDataStore(selectCurrentGroupData);
  return (
    <div className="modal-overlay">
      {regCodeRole && (
        <div className="modal-close" onClick={onCloseModal}>
          ×
        </div>
      )}

      <div style={{ textAlign: "center" }}>
        <div className="description-section">
          {!regCodeRole ? (
            <p>
              Provide group access via web link or QR code. No need to
              pre-register members. You are required to first set
              &apos;Fan&apos; (non-member) permissions in Fan Settings.
            </p>
          ) : regCodeRole === "fan" ? (
            <div>
              <p>
                Share link / QR at events and on social media to engage Fans
                (non-members).
              </p>
              <p>
                Manage permissions in Fan Settings and when publishing events,
                tickets, giveaways, etc.
              </p>
            </div>
          ) : (
            <p>
              Share link / QR code allowing registration. No need to
              pre-register members.
            </p>
          )}
        </div>

        <div className="select-section">
          <ChantSelect
            value={localRegCodeRole}
            placeholder="Set role"
            onChange={(value) => setLocalRegCodeRole(value)}
            options={ROLES.map((role) => ({
              value: role.value,
              label: role.label,
            }))}
          />

          <div className="action-section mt-4">
            <ChantButton
              onClick={async () => {
                await saveRegCodeRole(localRegCodeRole);
                onCloseModal();
              }}
              loading={isRoleSaving}
              disabled={
                localRegCodeRole === groupData?.regCodeRole || isRoleSaving
              }
            >
              Save
            </ChantButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegCodeRole;
